var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"global-window",attrs:{"id":"ResumoVenda"}},[_c('div',{attrs:{"id":"header"}},[_c('h3',[_vm._v("Resumo de Vendas")])]),_c('div',{attrs:{"id":"body"}},[_c('h3',[_vm._v("09/2020")]),_c('div',[_c('table',[_c('tbody',[_c('tr',[_c('td',[_vm._v("230192")]),_c('td',[_vm._v("11/04/2019")]),_c('td',[_vm._v("157,00")])])])]),_c('h4',[_vm._v("Total")])])])])
}]

export { render, staticRenderFns }